/* global DynamicRatingEnabled */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './DynamicRating.css';

const DynamicRating = ({ rating, subRatings }) => {
  if (!rating || !DynamicRatingEnabled) return null;

  const baseUrl = window.ExternalConfig ? window.ExternalConfig.ratingImages : '';
  const isHD = !!(subRatings && subRatings.indexOf('h') !== -1);
  const concatedSubRatings = subRatings ? subRatings.join('') : '';
  const prefixResolution = isHD ? 'HD' : 'SD';
  const suffixResolution = isHD ? 'H' : 'S';
  const extention = '.png';
  const path = '/LARGE/';

  const ratingStandardNaming = rating.replace('tv-', 'ltv');
  const ratings = (ratingStandardNaming + concatedSubRatings).toUpperCase();

  const imageUrl = [baseUrl, prefixResolution, path, ratings, suffixResolution, extention].join('');

  const classname = classNames([style.rating, isHD ? style.HD : null]);

  return (
    <div className={classname}>
      <img alt={rating} src={imageUrl} />
    </div>
  );
};

DynamicRating.defaultProps = {
  subRatings: [],
};

DynamicRating.propTypes = {
  rating: PropTypes.string.isRequired,
  subRatings: PropTypes.arrayOf(PropTypes.string),
};

export default DynamicRating;
